/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import TimeZoneConnected from '../../components/Common/TimeZone';

export const StyledTimeZone = styled(TimeZoneConnected)`
  margin-top: 10px;
  text-align: left;
`;

export const StyledGlobalWrapper = styled.div`${
  (props) => {
    const { styles } = props;
    const {
      color, 
      inputsLabelsTextAlign,
      inputsBorderRadius,
      calendarBorderRadius,
      calendarCellsBorderRadius,
      buttonsBorderRadius,
    } = styles.body || {};
    const {
      padding: containerPadding,
      margin: containerMargin,
      widgetContainerBorderRadius,
    } = styles.container || {};

    return css`
      input, select, textarea {
        border-radius: ${inputsBorderRadius}px !important;
      }
      
      button {
        border-radius: ${buttonsBorderRadius}px !important;
      }  
      
      .rdp-head {
        .rdp-head_row {
          border-radius: ${calendarBorderRadius}px;
        }
      }
      
      .rdp-cell {
        button.rdp-button {
          border-radius: ${calendarCellsBorderRadius}px !important;
        }
      }
      
      .styled-select {
        .bta-react-select__control {
          border-radius: ${inputsBorderRadius}px;
        }
        span[class$="indicatorSeparator"] {
          background-color: ${color};
        }
        div[class$="indicatorContainer"] {
          color: ${color};
        }  
      }
      .locations-select, .resources-select, .variant-select {
        .titles {
          display: inline-block;
          width: 100%;
          text-align: ${inputsLabelsTextAlign};
        }
      }

      .sub-panel {
        border-radius: ${widgetContainerBorderRadius}px;
        padding: ${containerPadding}px;
        margin: ${containerMargin}px; 
      }
    `;
  }
}`;
